import * as z from 'zod';

const phoneRegex = /^\(?\d{2}\)?\s?(?:9\d{4}|\d{4})-?\d{4}$/;

export const userInfoValidationSchema = z.object({
  name: z.string().optional(),
  personal_email: z
    .email('Email inválido')
    .optional()
    .nullable()
    .or(z.literal('')),
  phone: z
    .string()
    .refine(
      (value) => {
        const clearPhone = value.replace(/\D/g, '');
        return phoneRegex.test(clearPhone);
      },
      {
        message: 'Telefone inválido',
      }
    )
    .optional()
    .nullable()
    .or(z.literal('')),
  birthdate: z
    .string()
    .refine(
      (value) => {
        if (!value) return true;
        const parts = value.split('/');
        if (parts.length !== 3) return false;
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        if (isNaN(day) || isNaN(month) || isNaN(year)) return false;
        const date = new Date(year, month - 1, day);
        if (isNaN(date.getTime())) return false;
        const now = new Date();
        const minYear = now.getFullYear() - 120;
        const maxYear = now.getFullYear() - 12;
        return year >= minYear && year <= maxYear;
      },
      { message: 'Data inválida (deve ser entre 12 e 120 anos atrás)' }
    )
    .optional()
    .nullable()
    .or(z.literal('')),
});

export type UserInfoFormData = z.infer<typeof userInfoValidationSchema>;
